// src/components/ErrorBoundary.jsx
// Capture des erreurs applicatives → table Supabase error_logs.
// Inclut un Error Boundary React + un helper logError pour les erreurs async/globales.

import React from "react";
import { supabase } from "../supabase";

// Helper réutilisable : logue une erreur dans Supabase (best-effort, ne throw jamais).
export async function logError(error, context = {}) {
  try {
    let userId = null;
    try {
      const { data } = await supabase.auth.getSession();
      userId = data?.session?.user?.id || null;
    } catch { /* session indisponible, on continue en anonyme */ }

    await supabase.from("error_logs").insert({
      user_id: userId,
      message: (error && (error.message || String(error)))?.slice(0, 1000) || "Erreur inconnue",
      stack: (error && error.stack)?.slice(0, 4000) || null,
      context: {
        url: typeof window !== "undefined" ? window.location.href : null,
        userAgent: typeof navigator !== "undefined" ? navigator.userAgent : null,
        ...context,
      },
    });
  } catch (e) {
    console.error("[logError] échec du logging:", e);
  }
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logError(error, { componentStack: info?.componentStack, type: "react-boundary" });
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={wrap}>
          <div style={card}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>😕</div>
            <h2 style={{ margin: "0 0 8px", fontSize: 18, color: "#f1f5f9" }}>Une erreur est survenue</h2>
            <p style={{ fontSize: 13, color: "#9ca3af", lineHeight: 1.5, margin: "0 0 18px" }}>
              Pas de panique — l'erreur a été automatiquement signalée. Tu peux réessayer ou recharger l'application.
            </p>
            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
              <button onClick={this.handleReset} style={btnSecondary}>Réessayer</button>
              <button onClick={this.handleReload} style={btnPrimary}>Recharger l'app</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const wrap = {
  minHeight: "100dvh", display: "flex", alignItems: "center", justifyContent: "center",
  padding: 20, background: "#0a0a0f",
};
const card = {
  maxWidth: 420, width: "100%", textAlign: "center",
  background: "#0f0f13", border: "1px solid rgba(255,255,255,0.12)",
  borderRadius: 18, padding: 32,
};
const btnSecondary = {
  padding: "10px 18px", borderRadius: 9, border: "1px solid rgba(255,255,255,0.2)",
  background: "transparent", color: "#d1d5db", fontWeight: 600, cursor: "pointer", fontSize: 13,
};
const btnPrimary = {
  padding: "10px 18px", borderRadius: 9, border: "none",
  background: "#a78bfa", color: "#0f0f13", fontWeight: 700, cursor: "pointer", fontSize: 13,
};
